import type { CommonEditorTab } from "./reducers";
import type { NavbarMetadataTabContentFragment } from "../client/generated";
import { useTranslation } from "react-i18next";
import { Accordion } from "@acdc2/ui/components/accordion";
import { NavbarTabContent } from "../shell/NavbarTabContent";
import { MetadataLanguageAccordionItem } from "../metadata/MetadataLanguageAccordionItem";
import { MetadataTitleAccordionItem } from "../metadata/MetadataTitleAccordionItem";
import { MetadataAuthorAccordionItem } from "../metadata/MetadataAuthorAccordionItem";
import { MetadataKeywordAccordionItem } from "../metadata/MetadataKeywordAccordionItem";
import { MetadataDateAccordionItem } from "../metadata/MetadataDateAccordionItem";
import { ScrollArea } from "@acdc2/ui/components/scroll-area";

type Props = {
  fragment: NavbarMetadataTabContentFragment;
};

export function NavbarMetadataTabContent({ fragment }: Props) {
  const { t } = useTranslation();

  return (
    <NavbarTabContent
      value={"metadata" satisfies CommonEditorTab}
      title={t("NavbarMetadataTabContent.title")}
    >
      <ScrollArea className="flex-1">
        <Accordion
          type="multiple"
          defaultValue={["language", "titles", "authors", "keywords", "date"]}
          className="w-full"
        >
          <MetadataLanguageAccordionItem fragment={fragment} />
          <MetadataTitleAccordionItem fragment={fragment} />
          <MetadataAuthorAccordionItem fragment={fragment} />
          <MetadataKeywordAccordionItem fragment={fragment} />
          <MetadataDateAccordionItem fragment={fragment} />
        </Accordion>
      </ScrollArea>
    </NavbarTabContent>
  );
}
